import { memo, useState } from "react";
import { Modal } from "../Modal";
import { useDispatch } from "react-redux";
import { SelectSimulatedOverlayAction } from "./SelectSimulatedOverlayAction";
import { setSelectSimulatedOverlayOpen } from "../../../reducers/ownApp";
import { SELECT_SIMULATION } from "../../../consts/strings";
import { SelectSimulatedOverlayContent } from "./SelectSimulatedOverlayContent";
import { useEffect } from "react";

export const SelectSimulatedOverlay = memo(({ open, selectOverlay }) => {
  const [percentageModalValue, setPercentageModalValue] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setPercentageModalValue(null); // Resets value selected in case of different date selected
  }, [open]);

  const closeClick = () => {
    dispatch(setSelectSimulatedOverlayOpen(false));
  };

  return (
    <Modal
      open={open}
      onClose={closeClick}
      title={SELECT_SIMULATION}
      content={
        <SelectSimulatedOverlayContent
          setModalValue={setPercentageModalValue}
          modalValue={percentageModalValue}
        />
      }
      actions={
        <SelectSimulatedOverlayAction
          onCancel={closeClick}
          modalValue={percentageModalValue}
          selectOverlay={selectOverlay}
        />
      }
    />
  );
});
